import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FastSendLogo from "./FastSendLogo";

const RIDER_TABS = [
  { to: "/rider/dashboard", icon: "⚡", label: "Active Job" },
  { to: "/rider/wallet",    icon: "💰", label: "Wallet"     },
  { to: "/rider/history",   icon: "📜", label: "Trips"      },
  { to: "/rider/profile",   icon: "👤", label: "Profile"    },
  { to: "/rider/guide",     icon: "📖", label: "Guide"      },
];

export default function RiderNav() {
  const { logout, account } = useAuth();

  const isOnline = account?.isOnline;
  const isApproved = account?.approvalStatus === "approved";

  return (
    <>
      {/* ── Mobile-only floating logout — sibling of <nav>, not a child (see
          AdminNav.js for why: .app-nav's backdrop-filter creates a new
          containing block for fixed-position descendants). ── */}
      <button type="button" className="app-nav-mobile-logout" onClick={logout} aria-label="Log out">
        🚪
      </button>
      <nav className="app-nav">
      {/* ── Brand & Rider Profile (sidebar only) ── */}
      <div className="app-nav-brand">
        <Link to="/rider/dashboard" className="app-nav-logo-link" style={{ display: "inline-block", padding: "4px 0" }}>
          <FastSendLogo variant="horizontal" size="small" />
        </Link>
        {account && (
          <div className="app-nav-user">
            <div className="app-nav-avatar">
              {account.name?.charAt(0)?.toUpperCase() || "R"}
            </div>
            <div className="app-nav-user-info">
              <span className="app-nav-user-name">{account.name}</span>
              <span className="app-nav-user-role" style={{ color: isApproved && isOnline ? "var(--success)" : "var(--text-muted)" }}>
                {isApproved ? (isOnline ? "🟢 Online Dispatcher" : "⚫ Offline Dispatcher") : "Pending Dispatcher"}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* ── Nav Items ── */}
      <div className="app-nav-items">
        {RIDER_TABS.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `app-nav-item${isActive ? " active" : ""}`
            }
          >
            <span className="app-nav-item-icon">{icon}</span>
            <span className="app-nav-item-label">{label}</span>
          </NavLink>
        ))}
      </div>

      {/* ── Footer / Logout (sidebar only) ── */}
      <div className="app-nav-footer">
        <button className="app-nav-item app-nav-logout" onClick={logout}>
          <span className="app-nav-item-icon">🚪</span>
          <span className="app-nav-item-label">Log out</span>
        </button>
      </div>
      </nav>
    </>
  );
}
